module.exports = __webpack_public_path__ + "img/04.646e4f81.png";